<template>
  <div class="wrapper">
    <AppLogo variant="prelogin"/>
    <OTPInvitationForm/>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import AppLogo from "@/components/Widgets/AppLogo.vue";
import config from "@/utils/const/config";
import LangStorage from "@/utils/methods/lang_storage";
import { defaultLanguage } from "@/assets/i18n/i18n";
import OTPInvitationForm from "@/components/FK/UserForm/OTPInvitationForm.vue";

export default defineComponent({
  name: "OTPInvitationPage",
  components: {
    AppLogo,
    OTPInvitationForm
  },
  data: function() {
    return {
      lang: this.$route.query?.lang as string | undefined,
    }
  },
  mounted() {
    this.changeLocale(this.lang);
  },
  methods: {
    changeLocale(locale: string | undefined) {
      let lang_exists = config.available_locales.includes(locale ?? '');
      this.$i18n.locale = lang_exists ? (locale ?? defaultLanguage()) : defaultLanguage();
      LangStorage.set(this.$i18n.locale);
    },
  }
});
</script>